module.exports = __webpack_public_path__ + "assets/img/0d37f3e612b17374372813f23e43a4a8.svg";